import { render } from "./infraView.vue?vue&type=template&id=725eaa78"
import script from "./infraView.vue?vue&type=script&lang=js"
export * from "./infraView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__